import {NavLinkConfig} from './nav-link-config';

export class Section {
    navConfig: NavLinkConfig;
    component: any;
    attributes: any;
}
